"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertiesTableContentFragment = void 0;
exports.propertiesTableContentFragment = `
fragment propertiesTableContent on PropertiesTableContent {
  sections {
    title
    properties {
      key
      value
    }
  }
}
`;
//# sourceMappingURL=properties-table-content.js.map